/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import { GridColumnJustify } from '@veeam-vspc/shared/components';
import { capitalize } from '@veeam-vspc/shared/helpers';

import type { GridColumnProps } from '@veeam-vspc/shared/components';
import type { BackupServerConsumedPoints } from '@veeam-vspc/models/web-controllers';

import { TopDataUrls } from '../../../../enums';
import { useCommonSettings } from '../../../../hooks';
import { TopsGrid } from '../../../TopsGrid';
import { ConfigSectionIds } from 'core/enums';


import type { TopsGridComponentWrapper } from '../../../../interfaces';

export const BackupServersByConsumedPoints: React.FC<TopsGridComponentWrapper> = ({ maxNumberOfRows }) => {
    const settings =
        useCommonSettings<BackupServerConsumedPoints>({
            maxNumberOfRows,
            getDataRequestUrl: TopDataUrls.BackupServersByConsumedPoints,
        });
    const { lang } = settings;

    const columns: GridColumnProps<BackupServerConsumedPoints>[] = [
        {
            id: 'serverName',
            title: capitalize(lang.BACKUP_SERVER),
            cell: rowData => rowData.serverName,
        },
        {
            id: 'companyName',
            title: lang.COMPANY,
            cell: rowData => rowData.companyName,
        },
        {
            id: 'totalPoints',
            title: lang.TOTAL_POINTS,
            cell: rowData => rowData.totalPoints,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
        {
            id: 'availablePoints',
            title: lang.AVAILABLE_POINTS,
            cell: rowData => rowData.availablePoints,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
        {
            id: 'usedPoints',
            title: lang.USED_POINTS,
            cell: rowData => rowData.usedPoints,
            justify: GridColumnJustify.Right,
            headerJustify: GridColumnJustify.Right,
        },
    ];

    return (
        <TopsGrid
            title={lang.TOP_RENTAL_BACKUP_SERVERS_BY_CONSUMED_POINTS}
            columns={columns}
            sectionId={ConfigSectionIds.TopsInfrastructure}
            maxNumberOfRows={maxNumberOfRows}
            {...settings}
        />
    );
};
